// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// TruncationNotice — a bounded worklist says it is showing only part of the list (server `truncated`
// flag), so a capped list never looks complete. One component for every capped worklist (E-01 rule of
// two: Clinical Review, Lab Tracker and the enrollment queue each had their own copy).

export default function TruncationNotice({ shown, what, detail }: {
  /** How many rows are on screen (the server's cap). */
  shown: number
  /** What the rows are, plural ("therapies in review"). */
  what: string
  /** What the user can do about it, or how the rows were chosen. */
  detail?: string
}) {
  return (
    <div role="status" style={{
      fontSize: 12, color: '#92610f', background: '#fffbeb', border: '1px solid #f0c000',
      borderRadius: 8, padding: '7px 11px', marginBottom: 10,
    }}>
      Showing the first {shown} {what}. More exist than are shown{detail ? ` — ${detail}` : ''}.
    </div>
  )
}
